import PopupMessage from '../components/PopupMessage.vue';

function Install (Vue, options = {}) {
  const property = options.property || '$popupMessage';
  delete options.property;

  const Ctor = Vue.extend(Object.assign(PopupMessage));
  function createDialogCmp (options) {
    const container = document.querySelector('[data-app=true]') || document.body;
    return new Promise(resolve => {
      const cmp = new Ctor(Object.assign({}, {
        propsData: Object.assign({}, Vue.prototype[property].options, options),
        destroyed: () => {
          container.removeChild(cmp.$el);
          resolve(cmp.value);
        }
      }));
      container.appendChild(cmp.$mount().$el);
      var checkExist = setInterval(function() {
        if (document.querySelector('#popup-message-screen')) {
          cmp.$mount().$el.firstChild.className += ' open';
          cmp.$mount().$el.lastChild.className += ' open';
          clearInterval(checkExist);
        }
      }, 100);
    });
  }

  function show (title, message, options = {}) {
    options.title = title;
    options.message = message;
    return createDialogCmp(options);
  }

  Vue.prototype[property] = show;
  Vue.prototype[property].options = options || {};
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Install);
}

export default Install;
